<template>
    <v-container fluid>
        <PopupForm
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.add')"
        />
    </v-container>
</template>

<script>
import Popup from '@/models/settings/Popup'
import PopupForm from './Form'

export default {
    components: {
        PopupForm,
    },

    computed: {
        model() {
            return new Popup()
        },
    },

    methods: {
        saved() {
            console.log('saved')
            this.$router.go(-1)
        },
    },
}
</script>

<style></style>
